<template>
  <span>
    <main role="main">



      <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">

        <ul class="carousel-inner">
          <li class="carousel-item active">
            <div class="container">
              <div class="carousel-caption text-start">
                <h1>7% NET Rental Return.</h1>
                <ul>
                  <li>Completed and Tenanted</li>
                  <li>Rental Income Available</li>
                  <li>Student Property Investment</li>
                  <li>20.5% Projected Capital Growth by 2027</li>
                </ul>

                <form id="formR1" method="post" action="/sections/contact/agents/global_contactus.jsp"
                  class="inlineDisplay">
                  <fieldset class="inlineDisplay">
                    <input type="hidden" name="subject"
                      value="Property enquiry through hometolive.com : 7% NET Rental Return. LVP Area UK">
                    <input type="submit" name="submit" value="Enquire >" class="btn btn-lg btn-primary">
                  </fieldset>
                </form>



              </div>
            </div>
            <img src="/pub/vu/assets/images/hero4.jpg" style="object-fit: cover;" />
          </li>
          <li class="carousel-item">
            <div class="container">
              <div class="carousel-caption text-start">
                <h1>Find properties to rent in the uk.</h1>
                <p>Search for properties across uk.</p>
                <p><a class="btn btn-lg btn-primary" href="/sections/whitelabel/rentalSearch/renting_search.jsp"
                    role="button">Properties to rent</a></p>
              </div>
            </div>
            <img src="/pub/vu/assets/images/hero5.jpg" style="object-fit: cover;" />
          </li>
          <li class="carousel-item">
            <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
              <rect width="100%" height="100%" fill="#777" />
            </svg>
            <div class="container">
              <div class="carousel-caption">
                <h1>Find properties for sale.</h1>
                <p>Search for properties across uk to buy </p>
                <p><a class="btn btn-lg btn-primary" href="/sections/buying/buying_search.jsp" role="button">Properties
                    for Sale</a></p>
              </div>

            </div>
            <img src="/pub/vu/assets/images/hero2.jpg" style="object-fit: cover;" />
          </li>
          <li class="carousel-item">
            <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
              <rect width="100%" height="100%" fill="#777" />
            </svg>
            <div class="container">

              <div class="carousel-caption text-end">
                <h1>Login for adding properties.</h1>
                <p>Place your property ads for sale or to rent.</p>
                <p><a class="btn btn-lg btn-primary" href="/sections/customerAccess/login_form.jsp"
                    role="button">Login</a></p>
              </div>
            </div>
            <img src="/pub/vu/assets/images/hero3.jpg" style="object-fit: cover;" />
          </li>
          <li class="carousel-item">
            <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
              <rect width="100%" height="100%" fill="#777" />
            </svg>
            <div class="container">

              <div class="carousel-caption text-end">
                <h1>Resgistration for new users.</h1>
                <p>Place your property ads for sale or to rent.</p>
                <p><a class="btn btn-lg btn-primary" href="/sections/customerAccess/registration.jsp" role="button">Sign
                    up</a></p>
              </div>
            </div>
            <img src="/pub/vu/assets/images/hero1.jpg" style="object-fit: cover;" />
          </li>

          <div class="carousel-indicators">
            <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" class="active" aria-current="true"
              aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
            <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
          </div>
        </ul>

        <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </main>
  </span>
</template>




<script>
//import AllContent from '../data/content';

//const { content, introVideo } = AllContent.other;

export default {
  name: 'Homepage',

  data() {
    return {

    };
  }
};
</script>

<style scoped></style>
